var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"dia",attrs:{"visible":_vm.lemon,"width":"882px","before-close":_vm.chatClose},on:{"update:visible":function($event){_vm.lemon=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }